module.exports = __webpack_public_path__ + "static/media/bellatrix lestrange 3.6161b5be.jpg";